// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","caption":"fonts__caption____HpZ4e","body":"fonts__body____3cWGm","oldColorBlack":"#4a4a4a","oldColorWarmGray":"#bebbc8","oldColorViolet":"#652c91","checkItem":"check-item__checkItem____2Fdf6","tableCell":"check-item__tableCell____3ooPL","checkItemLabel":"check-item__checkItemLabel____1dcZi fonts__body____3cWGm","selected":"check-item__selected____aXZFY","disabled":"check-item__disabled____275sw","outlined":"check-item__outlined____3Oxki","hintText":"check-item__hintText____3xiWf fonts__caption____HpZ4e"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/check-item/check-item.css
// module id = 294
// module chunks = 0